module.exports = __webpack_public_path__ + "static/media/0323_IMG_TRAD_LE_PLAFOND_CHROMATIC_CH2_1039.04df12cd.webp";